import { Axios } from "../api/axios";
import { IAyceOrder } from "../pages/main/AyceMenu";
import { ICart } from "../types/menu";
import { logger } from "../utils/logger";

export interface ICallItems {
  callItemName: string;
  ordering: number;
  id: number;
}

export const getAyceMenuList = (storeId: number) => {
  return Axios(
    { 
      method: 'GET',
      url: `/v1/menus/ayce/stores/${storeId}`,
    }).then(response => {
      logger.log(response.data)
      return response;
    }).catch(error => {
      logger.log(error)
      return error
    } );
}

export const getOccupancyNGuest = (tableId: number) => {
  return Axios(
    { 
      method: 'GET',
      url: `/v1/users/ayce-menu-occupancy/tables/${tableId}`,
    }).then(response => {
      logger.log(response.data)
      return response;
    }).catch(error => {
      logger.log(error)
      return error
    } );
}

export const createAyceMenuOrder = (menuId: number, tableId: number, totalAmount: number, totalQuantity: number, orderItems: IAyceOrder[], storeId: number, tableName: string ) => {
  return Axios(
    { 
      method: 'post',
      url: 'v1/orders/ayce-menu',
      data: {
        menuId,
        storeId,
        tableName,
        tableId,
        totalAmount,
        totalQuantity,
        orderItems,
      }
    }).then(response => {
      return response;
    }).catch(error => logger.log(error));
}

export const createOrder = (tableId: number, totalAmount: number, totalQuantity: number, orderItems: ICart[], storeId: number, tableName: string) => {
  logger.log("~~",tableId, totalAmount, orderItems)
    return Axios(
      { 
        method: 'post',
        url: '/v1/orders',
        data: {
          storeId,
          tableName,
          tableId,
          totalAmount,
          totalQuantity,
          orderItems,
        }
      }).then(response => {
        return response;
      }).catch(error => logger.log(error));
};

export const getCheckBill = (tableId: number) => {
  logger.log(tableId)
  return Axios(
    { 
      method: 'GET',
      url: '/v1/orders/checks/tables/'+tableId,
    }).then(response => {
      logger.log(response.data)
      return response;
    }).catch(error => {
      logger.log(error)
      return error
    } );
}

export const checkRequest = (tableId: number) => {
  return Axios(
    { 
      method: 'patch',
      url: 'v1/orders/checks/tables/'+tableId
    }).then(response => {
      return response;
    }).catch(error => {
      return error
    });
}

export const getCallItems = (storeId:number) => {
  return Axios(
    { 
      method: 'get',
      url: '/orders/call-items/stores/'+storeId
    }).then(response => {
      return response
    });
};

export const saveCallItems = (data: {storeId: number, callItems: ICallItems[]}) => {
  return Axios(
    { 
      method: 'Put',
      url: 'orders/call-items',
      data: data
    }).then(response => {
      return response
    });
};

export const createCall = (tableId: string, callDetails: JSON[]) => {
  return Axios(
    { 
      method: 'POST',
      url: 'v1/orders/calls',
      data: {
        tableId,
        callDetails
      }
    }).then(response => {
      return response;
    }).catch(error => {
      logger.log(error)
      return error
    } );

}

export const updateCollect = async (storeId: any, number: string, collectInfo: any ) => {
  return  await Axios(
    { 
      method: 'POST',
      url: 'v1/events/collected-info',
      data: {
        storeId,
        phoneNo: number,
        orderAmount: Math.round(collectInfo.amount*100)
      }

    })
}

export const getTaxInfo = async (storeId: any, tableName: string, kioskOrderList: any) => {
  const {diningOption, userName, phoneNo, ...other} = kioskOrderList
  logger.log(other, kioskOrderList)

  return  await Axios(
    { 
      method: 'POST',
      url: 'clover-orders/checkout',
      data: {
        storeId,
        tableName,
        ...(phoneNo && { phoneNo: phoneNo.input }),
        ...other
      }

    }).then(response => {
      return response;
    }).catch(error => {
      logger.log(error)
      return error
    } );
}

export const createKioskOrder = async (storeId: any, tableName: string, kioskOrderList: any, tax: number, isRetry: boolean, isFinalTry: boolean, payload? : any) => {
  const {phoneNo, ...others} = kioskOrderList
  logger.log( kioskOrderList)
  return  await Axios(
    { 
      method: 'POST',
      url: 'v1/orders/kiosk',
      timeout: 180000,
      data: {
        storeId,
        tableName,
        tax,
        isRetry,
        isFinalTry,
        ...payload,
        ...(phoneNo && { phoneNo: phoneNo }),
        ...others
      }

    }).then(response => {
      return response;
    }).catch(error => {
      logger.log(error)
      return error
    } );
}

export const kioskReset = async (tableId: any) => {
  return await Axios(
    { 
      method: 'patch',
      url: `v1/orders/checks/tables/${tableId}/reset`,
    }).then(response => {
      return response;
    }).catch(error => {
      logger.log(error)
      return error
    } );
}

export const getNestModifierGroup = async(modifierId: number, storeId: number) => {
  return await Axios(
    { 
      method: 'get',
      url: `v2/menus/nested-modifier-groups/modifiers/${modifierId}/stores/${storeId}`
    }).then(response => {
      return response
    }).catch(error => {
      logger.log(error)
      return error
    } );
}
